
// import './App.css';
import MyPortfolio from './MyPortfolio';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  return (
    <div className="App">
       <MyPortfolio/>
    </div>
  );
}

export default App;
